var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 70,
    width: 250,
    xmlSpace: "preserve",
    viewBox: "100 30 600 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 595.28h841.89V0H0z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d42b77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m0 0-35.409-109.779h-25.52l20.511 63.581h-14.83l6.185 19.144z",
    transform: "matrix(1.33333 0 0 -1.33333 898.564 55.795)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 793.707)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#244e91",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m0 0 6.208 19.145h-72.351L-90.309.045l-9.383-29.068c-1.103-3.231-2.247-8.315-2.292-11.466-.085-6.03 2.5-12.262 6.879-16.306 4.967-4.586 10.446-6.786 19.619-6.786h54.968l6.178 19.145h-52.702c-3.386 0-6.006.789-7.858 2.366-1.853 1.576-2.777 3.702-2.777 6.382 0 1.299.234 2.598.623 3.897h59.655l6.189 19.146h-59.676L-66.806 0z",
    transform: "translate(601.262 507.236)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#244e91",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h-57.963l-28.832-42.664h25.155l16.133 23.636h21.525z",
    transform: "translate(349.542 486.32)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#244e91",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c-6.933 0-13.664-1.312-20.682-4.702-7.016-3.392-12.993-8.075-17.608-14.797-4.613-6.723-7.781-11.438-7.781-11.438h24.06l3.33 4.042c3.882 4.896 11.544 7.751 17.793 7.751h16.496L-4.913-82.727l23.482.002L45.246 0z",
    transform: "translate(343.769 526.382)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#244e91",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c-3.703 3.033-8.942 4.55-15.718 4.55h-41.604l-24.211-19.146-20.517-63.579h23.52l20.497 63.579h30.152c2.915 0 5.042-.432 6.381-1.3 1.34-.866 2.116-2.391 2.116-4.282 0-.481-.066-1.178-.347-2.057-.284-.879-1-3.107-1.886-5.833-.885-2.726-2.266-4.787-3.958-5.85-1.696-1.063-4.277-1.595-7.742-1.595h-22.157l23.54-42.662h24.008l-13.162 23.871c10.559 1.655 17.153 8.037 20.697 19.145l4.172 12.884c1.182 3.465 1.773 6.657 1.773 9.57C5.554-7.269 3.702-3.034 0 0",
    transform: "translate(484.506 521.83)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#244e91",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m0 0-6.146-19.145h-46.322c-19.983 0-32.567 19.493-26.402 38.503l3.556 10.97c6.428 19.824 24.896 33.252 45.738 33.252h56.459l-6.166-19.144h-48.9c-11.359 0-20.354-6.939-24.064-15.84-1.326-3.186-2.389-6.621-4.024-11.9C-58.793 8.558-54.414 0-46.009 0",
    transform: "translate(253.795 462.8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fd0f9bf21edd70fd4fb782ebbeea224a.svg";
export { ForwardRef as ReactComponent };